import React, { useEffect } from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import "../../assets/css/banner-ad-form.css";

const EditBanner = () => {
	useEffect(() => {
		let input = document.getElementById("inputTag");
		let imageName = document.getElementById("imageName");

		input.addEventListener("change", () => {
			let inputImage = document.querySelector("input[type=file]").files[0];

			imageName.innerText = inputImage.name;
		});
	}, []);
	return (
		<>
			{/* Modal popup starts here */}
			<div
				className="modal fade"
				id="exampleModal"
				tabindex="-1"
				aria-labelledby="exampleModalLabel"
				aria-hidden="true"
			>
				<div className="modal-dialog">
					<div className="modal-content">
						<div className="modal-content-wrapper">
							<div className="icon-wrapper">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="75.292"
									height="75.301"
									viewBox="0 0 75.292 75.301"
								>
									<path
										id="Icon_awesome-check-double"
										data-name="Icon awesome-check-double"
										d="M74.264,25.706l-5.823-5.823a3.515,3.515,0,0,0-4.985,0L28.238,55.1l-16.381-16.4a3.515,3.515,0,0,0-4.985,0L1.033,44.544a3.532,3.532,0,0,0,0,5l24.7,24.719a3.515,3.515,0,0,0,4.985,0L74.25,30.706A3.546,3.546,0,0,0,74.264,25.706ZM26.576,41.294a2.334,2.334,0,0,0,3.323,0L60.486,10.678a2.361,2.361,0,0,0,0-3.323L53.839.693a2.334,2.334,0,0,0-3.323,0L28.238,22.971,20.091,14.81a2.334,2.334,0,0,0-3.323,0l-6.661,6.661a2.361,2.361,0,0,0,0,3.323Z"
										transform="translate(0.004 0.002)"
										fill="#3e7439"
									/>
								</svg>
							</div>
							<div className="pop-content-wrapper">
								<h3>your Ads Banner Payment Was Successful </h3>
								<p>
									Your Banner Successful to Upload For <br /> This Website.
								</p>
								<a href="#" className="btn">
									Go To Home Page
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* Modal popup ends here */}
			{/* Header starts here */}
			<Header />
			{/* Header ends here */}
			{/* Banner ad form starts here */}
			<section className="banner-ad-form">
				<div className="container">
					<div className="row">
						<div className="col-lg-1"></div>
						<div className="col-lg-10">
							<div className="row">
								<div className="col-lg-3"></div>
								<div className="col-lg-6">
									<div className="banner-main-head-wrapper">
										<h2>Banner Ads</h2>
									</div>
									<div className="banner-form-wrapper">
										<div className="banner-add-heading-wrapper">
											<h3>Edit Your Brand</h3>
										</div>
										<div className="per-day-wrapper">
											<span className="property">
												Per Day Charges Your Brand Promotion :
											</span>
											<span className="value">$ 5.00</span>
										</div>
										<form action="">
											<div className="form-group row">
												<div className="col-lg-6">
													<label htmlFor="">Start Date</label>
													<input
														type="date"
														className="form-control"
														name=""
														id=""
													/>
												</div>
												<div className="col-lg-6">
													<label htmlFor="">End Date</label>
													<input
														type="date"
														className="form-control"
														name=""
														id=""
													/>
												</div>
											</div>
											<div className="form-group">
												<label htmlFor="">Upload Banner Image</label>
												<label className="tag" htmlFor="inputTag">
													<div className="fiel-wrapper">
														<span>Attach File</span>
														<i className="fa fa-paperclip"></i>
													</div>
													<input
														id="inputTag"
														type="file"
														name=""
														className="form-comtrol"
													/>
													<span id="imageName"></span>
												</label>
											</div>
											<div className="form-group">
												<label htmlFor="">Your Brand Link </label>
												<input
													type="text"
													placeholder="Paste Here"
													className="form-control"
												/>
											</div>
											<div className="adver-wrapper">
												<ul>
													<li>
														<span className="property">
															Advertise Banner Duration :
														</span>
														<span className="value">10 Days</span>
													</li>
													<li>
														<span className="property">Total Ads Price :</span>
														<span className="value">$ 40.00</span>
													</li>
												</ul>
											</div>
											<div className="form-group">
												<a
													className="form-control"
													// type="button"
													// className="form-control"
													// data-bs-toggle="modal"
													// data-bs-target="#exampleModal"
													href="/banner-ad"
												>
													Save changes
												</a>
											</div>
										</form>
									</div>
								</div>
								<div className="col-lg-3"></div>
							</div>
						</div>
						<div className="col-lg-1"></div>
					</div>
				</div>
			</section>
			{/* Banner ad form ends here */}
			{/* Footer starts here */}
			<Footer />
			{/* Footer ends here */}
		</>
	);
};

export default EditBanner;
